module.exports = __webpack_public_path__ + "img/cat.7fb3c24c.svg";